export default __webpack_public_path__ + "static/media/juego2_ganar.c9f0f325.png";